module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0018-892662c6b9ccc12f4af467f4dc6fabfd.jpg";